export default /* glsl */`
#ifdef USE_MAP

	vec4 texelColor = texture2D( map, vUv );

	texelColor = mapTexelToLinear( texelColor );

	float brightness = 0.2126 * texelColor.r + 0.7152 * texelColor.g + 0.0722 * texelColor.b;

	vec4 mappedTexelColor = vec4( mix(color0, color1, smoothstep(0.0, 1.0, brightness)), texelColor.a );
	vec4 influencedTexelColor = mix(texelColor, mappedTexelColor, smoothstep(0.0, 1.0, tintAccumulatedInfluence));

	diffuseColor *= influencedTexelColor;

#endif
`;
